<template>
  <dsf-dropdown-wrapper
    ref="dropdownWrapper"
    class="el-select dsf-tree-dropdown"
    :width="width"
    height="380px"
    @visible-change="visibleChange">
    <template #default>
      <div
        class="el-select__tags"
        v-if="multiple"
        ref="tags">
        <span v-if="collapseTags && selectedValue.length">
          <el-tag
            :closable="!disabled"
            :size="collapseTagSize"
            type="info"
            @close="deleteTag($event, selectedValue[0], 0)"
            disable-transitions>
            <span class="el-select__tags-text">{{ selectedValue[0].currentLabel }}</span>
          </el-tag>
          <el-tag
            v-if="selectedValue.length > 1"
            :closable="false"
            :size="collapseTagSize"
            type="info"
            disable-transitions>
            <span class="el-select__tags-text">+ {{ selectedValue.length - 1 }}</span>
          </el-tag>
        </span>
        <transition-group v-else @after-leave="resetInputHeight">
          <el-tag
            v-for="(item, i) in selectedValue"
            :key="item.value"
            :closable="!disabled"
            :size="collapseTagSize"
            type="info"
            @close="deleteTag($event, item, i)"
            disable-transitions>
            <span class="el-select__tags-text">{{ item.text }}</span>
          </el-tag>
        </transition-group>
        <input
          type="text"
          class="el-select__input"
          :class="[selectSize ? `is-${ selectSize }` : '']"
          :disabled="selectDisabled"
          :autocomplete="autoComplete || autocomplete"
          @focus="handleFocus"
          @blur="softFocus = false"
          @keyup="managePlaceholder"
          @keydown="resetInputState"
          @keydown.down.prevent="handleNavigate('next')"
          @keydown.up.prevent="handleNavigate('prev')"
          @keydown.enter.prevent="selectOption"
          @keydown.esc.stop.prevent="visible = false"
          @keydown.delete="deletePrevTag"
          @keydown.tab="visible = false"
          @compositionstart="handleComposition"
          @compositionupdate="handleComposition"
          @compositionend="handleComposition"
          v-model="query"
          @input="debouncedQueryChange"
          v-if="filterable"
          :style="{ 'flex-grow': '1', width: inputLength / (inputWidth - 32) + '%', 'max-width': inputWidth - 42 + 'px' }"
          ref="input">
      </div>
      <el-input
        ref="reference"
        v-model="selectedValue.text"
        :placeholder="currentPlaceholder"
        :name="name"
        :id="id"
        :autocomplete="autocomplete"
        :size="selectSize"
        :disabled="selectDisabled"
        :validate-event="false"
        :class="{ 'is-focus': visible }"
        :tabindex="multiple ? '-1' : null"
        type="text"
        readonly
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown.native.esc.stop.prevent="visible = false"
        @keydown.native.tab="visible = false"
        @compositionstart="handleComposition"
        @compositionupdate="handleComposition"
        @compositionend="handleComposition"
        @mouseenter.native="inputHovering = true"
        @mouseleave.native="inputHovering = false">
        <template slot="prefix" v-if="$slots.prefix">
          <slot name="prefix"></slot>
        </template>
        <template slot="suffix">
          <i :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"></i>
          <i v-if="showCloseCopy" class="el-select__caret el-input__icon el-icon-circle-close" @click="handleClearClick"></i>
        </template>
      </el-input>
    </template>
    <template #dropdown>
      <dsf-tree-select
        ref="tree"
        :tree-data="options"
        :loading="treeLoading"
        :default-checked-key="dictRmId"
        :get-no-check="getNoCheck"
        :multiple="multiple"
        :check-strictly="checkStrictly"
        node-key="_id"
        node-name="_name"
        node-children="children"
        search-control
        default-expand-all
        @choose-node="chooseNode"
      />
    </template>
  </dsf-dropdown-wrapper>
</template>

<script>
// 下拉树选择器
export default {
  name: "DsfTreeDropdown",
  props: {
    id: String,
    name: String,
    size: String,
    multiple: Boolean,
    collapseTags: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    checkStrictly: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Object, Array],
      default: null
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      width: 'auto',
      selectedLabel: '',
      currentPlaceholder: '',
      visible: false,
      inputHovering: false,
      treeLoading: false,
      dictRmId: '',
    }
  },
  computed: {
    collapseTagSize() {
      return ['small', 'mini'].indexOf(this.size) > -1
        ? 'mini'
        : 'small';
    },
    iconClass() {
      return this.visible ? 'arrow-up is-reverse' : 'arrow-up';
    },
    selectedValue() {
      let val = this.value;
      if (this.multiple) {
        return dsf.isObject(val) ? [val] : dsf.isArray(val) ? val : [];
      }
      return dsf.isObject(val) ? val : dsf.isArray(val) && val.length ? val[0] : {text: '', value: ''};
    },
    showCloseCopy() {
      if (!this.showClose) return false;
      if (this.multiple) {
        return this.selectedValue.length > 0
      }
      return !!this.selectedValue?.value
    }
  },
  created() {
    if (this.multiple) {
      this.dictRmId = _.map(this.selectedValue, 'value');
    } else {
      this.dictRmId = this.selectedValue.value;
    }
  },
  methods: {
    visibleChange(visible) {
      if (visible) {
        this.width = this.getWidth();
      } else {
        // this.hideHandler();
      }
      this.visible = visible;
    },
    getWidth() {
      let width = this.$el?.offsetWidth;
      if (width < 320) width = 320;
      return width + 'px' || "auto";
    },
    handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          if (this.filterable && !this.visible) {
            this.menuVisibleOnFocus = true;
          }
          this.visible = true;
        }
        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    handleBlur(event) {
      setTimeout(() => {
        if (this.isSilentBlur) {
          this.isSilentBlur = false;
        } else {
          this.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleClearClick(event) {
      this.deleteSelected(event);
      this.$refs.tree.resetChecked();
      this.$refs.dropdownWrapper.toggleDropDownVisible(false);
    },
    deleteSelected(event) {
      event.stopPropagation();
      const value = this.multiple ? [] : {
        text: '',
        value: ''
      };
      this.$emit('input', value);
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag(e, item, index) {
      this.$refs.tree.setChecked(item.value, false);
      let val = this.value;
      if (dsf.isObject(val)) {
        this.$emit('input', []);
        return;
      }
      if (dsf.isArray(val)) {
        val.splice(index, 1);
      }
    },
    getNoCheck(node) {
      return !!node['children']?.length;
    },
    chooseNode(node) {
      if (!this.multiple) {
        if (node == null) {
          this.$emit('input', null);
        } else {
          this.$emit('input', {
            text: node._name,
            value: node._id
          });
        }
      } else if (node == null) {
        this.$emit('input', []);
      } else {
        this.$emit('input', _.map(node, n => {
          return {
            text: n._name,
            value: n._id
          }
        }));
      }
    }
  }
}
</script>